import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Client, Message, Stomp, StompHeaders, StompSubscription } from '@stomp/stompjs';

import SockJS from 'sockjs-client';

import { filter, first, switchMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { AppConstants, SocketClientState } from '../../constants/constants';
import { PageableResponse } from '../../models/pageable-response.model';
import { NotificationModel } from '../models/notification.model';
import { NotificationsState } from '../state/notifications.state';

//_httpClients://dimitr.im/websockets-angular
@Injectable({
  providedIn: 'root'
})
export class NotificationService implements OnDestroy {
  private stompClient;
  private soketState: BehaviorSubject<SocketClientState>;

  constructor(private _httpClient: HttpClient) {
    const wsFactory = () => new SockJS(environment.notificationsWebSocketApi);
    this.stompClient = Stomp.over(wsFactory);

    // Configure auto-reconnect
    this.stompClient.reconnectDelay = 5000;


    let token = localStorage.getItem(AppConstants.PRISISTED_KEYS.ACCESS_TOKEN)
    let headers: StompHeaders = {
      "X-Authorization": 'Bearer ' + token
    }
    this.stompClient.connect(headers, (frame: any) => {
      // console.log('Connected: ' + frame);
      this.stompClient.subscribe('/user/queue/notifications', (notification) => {
        const message = JSON.parse(notification.body)
        //console.log(message);
        NotificationsState.setSocketNotificationState(message)
      });

      this.stompClient.subscribe('/user/queue/events', (notification) => {
        const message = JSON.parse(notification.body)
        //console.log(message);
        NotificationsState.setSocketEventState(message)
      });

    });
  }

  markAllUserNotificationAsRead(): Observable<any> {
    const url = `${AppConstants.API.NOTIFICATIONS_API}/read`;
    return this._httpClient.get<any>(url);
  }

  connect(): Observable<Client> {
    return new Observable<Client>(observer => {
      this.soketState.pipe(filter(state => state === SocketClientState.CONNECTED)).subscribe(() => {
        observer.next(this.stompClient);
      });
    });
  }

  onMessage(topic: string, handler = NotificationService.jsonHandler): Observable<any> {
    return this.connect().pipe(first(), switchMap(inst => {
      return new Observable<any>(observer => {
        const subscription: StompSubscription = inst.subscribe(topic, message => {
          observer.next(handler(message));
        });
        return () => inst.unsubscribe(subscription.id);
      });
    }));
  }

  onPlainMessage(topic: string): Observable<string> {
    return this.onMessage(topic, NotificationService.textHandler);
  }

  static jsonHandler(message: Message): any {
    return JSON.parse(message.body);
  }

  static textHandler(message: Message): string {
    return message.body;
  }

  getAllNotifications(page: number, size: number): Observable<PageableResponse<NotificationModel[]>> {
    const url = `${AppConstants.API.NOTIFICATIONS_API}?page=${page}&size=${size}`;
    return this._httpClient.get<PageableResponse<NotificationModel[]>>(url);
  }

  getNotificationById(notificationId: any): Observable<any> {
    const url = `${AppConstants.API.NOTIFICATIONS_API}/${notificationId}`;
    return this._httpClient.get(url);
  }

  ngOnDestroy() {
    if (this.stompClient != null) {
      this.stompClient.disconnect((null));
    }
  }
}